/** D24 -- Birthdays + Work Anniversaries widget for the Home dashboard. */
import React, { useEffect, useState } from "react";
import { Cake, Trophy } from "lucide-react";
import api from "@/lib/api";

export default function CelebrationsWidget() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/celebrations/today").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data) return null;
  const hasToday = (data.birthdays?.length || 0) + (data.anniversaries?.length || 0) > 0;
  const hasWeek = (data.upcoming?.birthdays?.length || 0) + (data.upcoming?.anniversaries?.length || 0) > 0;
  if (!hasToday && !hasWeek) return null;
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4"
         data-testid="celebrations-widget">
      <div className="text-[10px] uppercase tracking-[0.18em] text-foreground/55 mb-2">
        {hasToday ? "🎉 Today's celebrations" : "Upcoming this week"}
      </div>
      <div className="space-y-1.5">
        {hasToday
          ? (
            <>
              {data.birthdays.map((b) => (
                <div key={`b-${b.user_id}`} className="text-sm flex items-center gap-1.5"
                     data-testid={`celeb-bday-${b.user_id}`}>
                  <Cake className="h-3.5 w-3.5 text-pink-300" />
                  <span className="text-foreground/90">{b.name}</span>
                  {b.department && <span className="text-foreground/50 text-[11px]">· {b.department}</span>}
                </div>
              ))}
              {data.anniversaries.map((a) => (
                <div key={`a-${a.user_id}`} className="text-sm flex items-center gap-1.5"
                     data-testid={`celeb-anniv-${a.user_id}`}>
                  <Trophy className="h-3.5 w-3.5 text-amber-300" />
                  <span className="text-foreground/90">{a.name}</span>
                  <span className="text-foreground/60 text-[11px]">· {a.years}-year work anniversary</span>
                </div>
              ))}
            </>
          )
          : (
            <>
              {data.upcoming.birthdays.slice(0, 3).map((b) => (
                <div key={`ub-${b.user_id}`} className="text-[12px] flex items-center gap-1.5">
                  <Cake className="h-3 w-3 text-pink-300" />
                  <span>{b.name}</span>
                  <span className="text-foreground/50 ml-auto">{b.on?.slice(5)}</span>
                </div>
              ))}
              {data.upcoming.anniversaries.slice(0, 3).map((a) => (
                <div key={`ua-${a.user_id}`} className="text-[12px] flex items-center gap-1.5">
                  <Trophy className="h-3 w-3 text-amber-300" />
                  <span>{a.name}</span>
                  <span className="text-foreground/50 ml-auto">{a.on?.slice(5)}</span>
                </div>
              ))}
            </>
          )
        }
      </div>
    </div>
  );
}
